import { useState, useEffect, useMemo } from 'react';
import { SuiteManifest, SuiteNavItem } from '@suites/manifest';

const STORAGE_KEY = 'helios_custom_objects';

const DEFAULT_CUSTOM_OBJECTS = [
  { slug: 'partner_tier', label: 'Partner Tier', icon: 'award' },
  { slug: 'it_asset', label: 'Company Asset', icon: 'laptop' },
];

function getCustomObjects(): Array<{ slug: string; label: string; icon?: string }> {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (raw) {
      const parsed = JSON.parse(raw);
      if (Array.isArray(parsed) && parsed.length > 0) return parsed;
    }
  } catch {
    // ignore
  }
  return DEFAULT_CUSTOM_OBJECTS;
}

export function useDynamicNav(activeSuite?: SuiteManifest): SuiteNavItem[] | undefined {
  const [customObjects, setCustomObjects] = useState(getCustomObjects);

  useEffect(() => {
    const update = () => setCustomObjects(getCustomObjects());
    window.addEventListener('helios-custom-objects-updated', update);
    window.addEventListener('storage', update);
    return () => {
      window.removeEventListener('helios-custom-objects-updated', update);
      window.removeEventListener('storage', update);
    };
  }, []);

  return useMemo(() => {
    if (!activeSuite?.nav) return undefined;
    if (activeSuite.id !== 'core') return activeSuite.nav;

    return activeSuite.nav.map((item) => {
      if (item.path === '/core/basic/custom-objects') {
        const children: SuiteNavItem[] = [
          {
            label: 'All Objects',
            path: '/core/basic/custom-objects',
            icon: 'boxes',
          },
          ...customObjects.map((co) => ({
            label: co.label,
            path: `/core/basic/custom-objects?object=${co.slug}`,
            icon: co.icon || 'box',
          })),
        ];

        return {
          ...item,
          children,
        };
      }
      return item;
    });
  }, [activeSuite, customObjects]);
}
